import React from 'react';
import './DeviceSectionNav.css';

/**
 * Sticky “Jump to” section links for device view / edit.
 */
function DeviceSectionNav({ links = [], onNavigate, inModal = false }) {
  if (!links.length) return null;

  return (
    <nav
      className={`device-section-nav${inModal ? ' device-section-nav--in-modal' : ''}`}
      aria-label="Jump to device detail sections"
    >
      <div className="device-section-nav-label">Jump to</div>
      <div className="device-section-nav-scroll">
        <div className="device-section-nav-links">
          {links.map((link) => (
            <button
              key={link.id}
              type="button"
              className="device-section-nav-link"
              title={`Jump to ${link.label}`}
              onClick={() => onNavigate(link.id)}
            >
              {link.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default DeviceSectionNav;
